import React from 'react';
import './programs.css';
import { connect } from 'react-redux';
import {
  updateProgramFilter,
  updateSelectedProgram
} from '../../../actions/adminActions/programsActions';
import { programs } from '../../../apis/backend'; //make sure to include this for each page
import EditProgramModal from './programModals/editProgramModal.jsx';
import AddProgramModal from './programModals/addProgramModal.jsx';

class Programs extends React.Component {
  async programDeleteRequest(id) {
    await programs
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  renderprograms() {
    //renders the programs table
    return (
      <>
        {this.props.programs
          .filter((program) => {
            const filterString = `${program.name}`;
            return filterString.toLowerCase().indexOf(this.props.programFilter.toLowerCase()) > -1;
          })
          .map((program) => (
            <tr key={this.props.programs.indexOf(program)}>
              <td className="text-center" style={{ width: '24%' }}>
                {`${program.name}`}
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedProgram(program.id);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#deleteModal"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedProgram(program.id);
                  }}
                >
                  Remove
                </div>
              </td>
            </tr>
          ))}
      </>
    );
  }

  getProgramName() {
    const program = this.props.programs.find((obj) => obj.id === this.props.selectedProgram);

    return program ? program.name : '';
  }

  render() {
    return (
      <div className="programs-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>Programs</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.programFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updateProgramFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark permission-super-admin"
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Add Program
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '24%' }}>
                    Name
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Edit
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderprograms()}</tbody>
            </table>
          </div>
        </div>

        <AddProgramModal />
        <EditProgramModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedProgram(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getProgramName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.programDeleteRequest(this.props.selectedProgram);
                    this.props.updateSelectedProgram(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedProgram(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  programs: state.admin.admin.programs,
  programFilter: state.admin.programs.programFilter,
  selectedProgram: state.admin.programs.selectedProgram,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateProgramFilter,
  updateSelectedProgram
})(Programs);
